import styled, { css } from "vue-styled-components";

export const SWrapper = styled.fieldset`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;

    label {
      margin: 0 0 12px 0;
      font-family: ${theme.font.family.inter}, sans-serif;
      font-weight: ${theme.font.family.regular};
      font-size: ${theme.font.size.md};
      line-height: 128%;
      color: ${theme.colors.neutral.gray6};
    }

    select {
      position: relative;
      padding: 18px 20px;
      border: 1px solid ${theme.colors.neutral.gray4};
      border-radius: 8px;
      background: ${theme.colors.neutral.white}
        url(${require("../../assets/images/arrow-down-icon.svg")}) no-repeat
        right 18px center/12px 16px !important;
      -moz-appearance: none;
      -webkit-appearance: none;
      appearance: none;
      transition: all 0.3s ease;

      &:hover:enabled,
      &:focus:enabled,
      &.focus:enabled,
      &:active:enabled,
      &.active:enabled {
        border-color: ${theme.colors.neutral.gray8};
        outline: none;
        box-shadow: none;
      }
    }
  `}
`;
